module.exports = __webpack_public_path__ + "static/media/pause.308e7744.svg";